import { SVGProps } from 'react';

export const FacilityIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52' fill='none' {...props}>
    <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth={2.5} d='M47.667 45.5H4.334' />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.5}
      d='M5.003 14.107 8.53 8.52a4.333 4.333 0 0 1 3.664-2.02h27.61c1.488 0 2.87.762 3.665 2.02l3.528 5.587c.437.692.669 1.494.669 2.313v5.247c0 1.196-.97 2.166-2.167 2.166h-39a2.167 2.167 0 0 1-2.166-2.166V16.42c0-.819.232-1.62.669-2.313Z'
      clipRule='evenodd'
    />
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.5}
      d='M8.508 45.5V23.833M43.333 45.5V23.833M21.667 45.5V23.86M47.48 15.166H4.52'
    />
  </svg>
);
